import {AdministrativeAndFunctionalZonePurpose} from "../model/administrative-and-functional-zone/AdministrativeAndFunctionalZone";

export const purposesToString = new Map<AdministrativeAndFunctionalZonePurpose, string>([
    [AdministrativeAndFunctionalZonePurpose.WAREHOUSE, 'Склад'],
    [AdministrativeAndFunctionalZonePurpose.PRODUCTION_AREA, 'Производственный участок'],
    [AdministrativeAndFunctionalZonePurpose.WORKSHOP, 'Производственный цех'],
    [AdministrativeAndFunctionalZonePurpose.PRODUCTION_LINE, 'Производственная линия']
])